import React from 'react';

import { useAuth } from '../../context/auth';

type IClaims = {
  claimsBlock: Array<string>;
  children: React.ReactNode;
  text?: string;
};

const ClaimsProvider: React.FC<IClaims> = (props) => {
  const { claims, isAdmin }: any = useAuth();

  if (props.claimsBlock!.indexOf('all') > -1) {
    return <>{props.children}</>;
  }

  //проверить есть ли совпадения в двух массивах
  let guardBoard = false;
  for (let item of props.claimsBlock) {
    if (item === 'admin' && isAdmin) {
      guardBoard = true;
      break;
    }

    if (claims!.indexOf(item) > -1) {
      guardBoard = true;
      break;
    } else {
      guardBoard = false;
    }
  }

  if (guardBoard) {
    return <>{props.children}</>;
  } else {
    return <>{props.text}</> || null;
  }
};

export default ClaimsProvider;
